import guestMiddleware from './../middleware/guestMiddleware';
import { PersonTypeId, PersonTypeOperation } from '@/constants/personTypeAccess';
// import { createPinia } from 'pinia';
import { useAuthStore } from "@/state/pinia";

// const pinia = createPinia();
// const useAuth = useAuthStore(pinia);

export default [
  //#region Standard Dashboard Routes.
  //#region Auth Routes.
  {
    path: '/',
    name: 'default',
    redirect: () => {
      const authStore = useAuthStore(); // Access the store dynamically
      return authStore.loggedIn ? '/statistics' : '/login';
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login'),
    beforeEnter: guestMiddleware
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/account/logout')
  },
  //#endregion

  //#region Errors Routes.
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: '/404',
  },
  {
    path: "/404",
    name: "Error-404",
    meta: { title: "404 Error Page" },
    component: () => import("../views/utility/404")
  },
  {
    path: "/500",
    name: "Error-500",
    meta: { title: "500 Error Page" },
    component: () => import("../views/utility/500")
  },
  //#endregion

  //#region Admin Cms Routes.
  
  //#region Statistics
  {
    path: '/statistics',
    name: 'statistics',
    meta: { title: "statistics", middleware: ['authMiddleware'],},
    component: () => import("../views/statistics/statistics"),
  },
  //#endregion

  //#region Admins
  {
    path: '/admins',
    name: 'admins.index',
    meta: { title: "index", middleware: ['authMiddleware', 'canMiddleware:showAdmin|addAdmin|editAdmin|deleteAdmin|resetAdminPassword'] },
    component: () => import('../views/admins/index')
  },
  {
    path: '/admins/account',
    name: 'admins.account',
    meta: { title: "admins account", middleware: ['authMiddleware'] },
    component: () => import('../views/account/account-info')
  },
  //#endregion

  //#region Add Sacrificer(Martyrs,Woundeds,Deceaseds)
  {
    path: "/sacrificers-with-beneficiaries",
    name: "sacrificers-with-beneficiaries.index",
    meta: { title: "sacrificers-with-beneficiaries index", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.MARTYR}-${PersonTypeOperation.READ}|${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ}|${PersonTypeId.DECEASED}-${PersonTypeOperation.READ}|${PersonTypeId.MARTYR_FAMILY}-${PersonTypeOperation.READ}|${PersonTypeId.WOUNDED_FAMILY}-${PersonTypeOperation.READ}|${PersonTypeId.DECEASED_FAMILY}-${PersonTypeOperation.READ}`] },
    component: () => import("../views/all_data/all_categories")
  },
  {
    path: '/sacrificers/add',
    name: 'sacrificers.add',
  meta: { title: "sacrificers add", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.MARTYR}-${PersonTypeOperation.CREATE}|${PersonTypeId.WOUNDED}-${PersonTypeOperation.CREATE}|${PersonTypeId.DECEASED}-${PersonTypeOperation.CREATE}`] },
    component: () => import('../views/Basic_Data/person')
  },
  //#endregion

  //#region Martyrs
  {
    path: "/martyrs",
    name: "martyrs.index",
    meta: { title: "martyrs index", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.MARTYR}-${PersonTypeOperation.READ}`] },
    component: () => import("../views/all_data/martyrs")
  },
  {
    path: '/martyrs/:id',
    name: 'martyrs.details',
    meta: { title: "martyrs details", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/Details/martyrs_details')
  },
  {
    path: '/martyrs/edit/:id',
    name: 'martyrs.edit',
    meta: { title: "martyrs edit", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/all_martyrs_data')
  },
  //#endregion
  
  //#region Woundeds
  {
    path: "/woundeds",
    name: "woundeds.index",
    meta: { title: "woundeds index", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.WOUNDED}-${PersonTypeOperation.READ}`] },
    component: () => import("../views/all_data/wounded")
  },
  {
    path: '/woundeds/:id',
    name: 'woundeds.details',
    meta: { title: "wounded details", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/Details/wounded_details')
  },
  {
    path: '/woundeds/edit/:id',
    name: 'woundeds.edit',
    meta: { title: "wounded edit", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/all_wounded_data')
  },
  //#endregion

  //#region Deceaseds
  {
    path: "/deceaseds",
    name: "deceaseds.index",
    meta: { title: "deceaseds index", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.DECEASED}-${PersonTypeOperation.READ}`] },
    component: () => import("../views/all_data/deceased")
  },
  {
    path: '/deceaseds/:id',
    name: 'deceaseds.details',
    meta: { title: "deceaseds details", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/Details/deceased_details')
  },
  {
    path: '/deceaseds/edit/:id',
    name: 'deceaseds.edit',
    meta: { title: "deceaseds edit", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/all_deceased_data')
  },
  //#endregion

  //#region Beneficiaries
  {
    path: "/beneficiaries",
    name: "beneficiaries.index",
    meta: { title: "beneficiaries index", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.MARTYR_FAMILY}-${PersonTypeOperation.READ}|${PersonTypeId.WOUNDED_FAMILY}-${PersonTypeOperation.READ}|${PersonTypeId.DECEASED_FAMILY}-${PersonTypeOperation.READ}`] },
    component: () => import("../views/all_data/beneficiaries")
  },
  {
    path: '/beneficiaries/:id',
    name: 'beneficiaries.details',
    meta: { title: "beneficiaries details", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/Details/beneficiary_details')
  },
  {
    path: '/beneficiaries/edit/:id/:relationshipType',
    name: 'beneficiaries.edit',
    meta: { title: "beneficiaries edit", middleware: ['authMiddleware'] },
    component: () => import('../views/Basic_Data/all_beneficiary_data')
  },
  {
    path: '/beneficiaries/add/:id',
    name: 'beneficiaries.add',
    meta: { title: "beneficiaries add", middleware: ['authMiddleware', `canPersonTypeOperationMiddleware:${PersonTypeId.MARTYR_FAMILY}-${PersonTypeOperation.CREATE}|${PersonTypeId.WOUNDED_FAMILY}-${PersonTypeOperation.CREATE}|${PersonTypeId.DECEASED_FAMILY}-${PersonTypeOperation.CREATE}`] },
    component: () => import('../views/Basic_Data/add_beneficiary'),
  },
  //#endregion

  //#region System Settings
  {
    path: '/system/settings',
    name: 'system.settings',
    meta: { title: "system settings", middleware: ['authMiddleware', 'canMiddleware:manageRequiredFieldSettings|manageGovernorateSettings|manageEmployeePositionsSettings|manageUniversitySettings|manageAttachmentsSettings|manageSkillSettings|manageCategorySettings|manageAdmissionChannelSettings|manageAlmelakatSettings|manageBodySideSettings|manageBodyMainPartSettings|manageBodySubPartSettings|manageHousingTypeSettings|manageInstitutionSettings|manageIssuerNewIdentificationCardSettings|manageIssuerOldIdentificationCardSettings|manageIssuerPassportSettings|manageIssuerResidentialCardSettings|manageLevelOneSettings|manageLevelTwoSettings|manageLevelThreeSettings|manageOwnershipTypeSettings|managePersonTypeSettings|managePlaceAffiliationSettings|manageTypeInjurySettings'] },
    component: () => import('../views/settings/SystemSettings')
  },
  //#endregion

  
  {
    path: "/all_data/all_categories",
    name: "all_categories",
    meta: { title: "all_categories", /* middleware: ['authMiddleware']*/ },
    component: () => import("../views/all_data/all_categories")
  },
  // uds
  
  
  
  //#endregion
  {
    path: '/settings/map',
    name: 'map',
    component: () => import('../views/settings/map')
  },
  //#endregion Standard Dashboard Routes.
];
